// Experience.js

import { Box, Flex } from '@chakra-ui/react';
import SEWhite from '../images/SEWhite.svg';
import zenithLogo from '../images/zenithLogo.svg';
import bbpLogo from '../images/bbpLogo.png';
import ExperienceCard from '../components/ExperienceCard';
import { useState } from 'react';

const zenithWork = {
    jobTitle: "Co-Founder/Chief Operating Officer",
    companyName: "Zenith Software",
    startDate: "September 2021",
    endDate: "Present",
    description: "Co-founded a startup at age 19, leading a team of developers and designing innovative products. Focused on UI/UX design, product development, and company growth, while managing and mentoring a team of seven full-time developers. Led the development of multiple projects from conception to market launch.",
    image: zenithLogo,
    projects: {
        "Cantaloupe" : "https://www.trycantaloupe.com/",
        "AURA": "https://www.auraadco.com/",
        "Earshot": "https://apps.apple.com/us/app/earshot-proximity-chat/id6471038992",
    },
    tags: ["React.js", "TypeScript", "UI/UX", "Figma", "Agile", "Leadership", "App Development"],
    link: "https://zenithsoftware.dev"
};

const speakEasyWork = {
    jobTitle: "Manager/Booking Agent/Bassist",
    companyName: "Speak Easy",
    startDate: "April 2021",
    endDate: "Present",
    description: "Lead a group of musicians, manage performances, and oversee releases. Developed a custom website using React.js and AWS, managed social media presence, and improved user experience through data-driven strategies. Skilled in multi-tasking, team management, and effective communication.",
    image: SEWhite,
    projects: {
        "speakeasybandbr.com": "https://www.speakeasybandbr.com/",
        "Instagram": "https://www.instagram.com/speakeasybandbr/",
        "Spotify": "https://open.spotify.com/artist/6DttflSZKb9uIGnXBDugdj?si=iF24Aa2-SeWOOXKzhUPadw",
    },
    tags: ["Management", "Leadership", "Social Media", "AWS", "Marketing", "Advertising"],
    link: "https://www.speakeasybandbr.com/"
};

const bbpWork = {
    jobTitle: "Frontend Web Developer",
    companyName: "BBP Sales",
    startDate: "October 2021",
    endDate: "November 2022",
    description: "Gained professional experience in a high-responsibility role, meeting strict deadlines with high-quality work. Taught myself web development fundamentals and contributed to a large-scale employee portal project designed to automate inside sales.",
    image: bbpLogo,
    projects: {},
    tags: ["Web Development", "HTML", "CSS", "JavaScript"],
    link: "https://www.bbpsales.com/"
};

export default function Experience() {
    const [is1Hovered, setIs1Hovered] = useState(false);
    const [is2Hovered, setIs2Hovered] = useState(false);
    const [is3Hovered, setIs3Hovered] = useState(false);
    const [hoverActive, setHoverActive] = useState(false);

    return (
        <Flex
            id="experience"
            flexDirection={"column"}
            alignItems="center"
            justifyContent="space-between"
            padding="5%"
            paddingLeft={"10%"}
            paddingRight={"10%"}
            backgroundColor={"black.200"}
            minW={"100%"}
        >
            <Box
                fontSize={"4xl"}
                fontFamily={"Source Code Pro Variable"}
                fontWeight="600"
                width={"100%"}
                textAlign={"center"}
                color={"white.200"}
                marginBottom={"2%"}
            >
                Work Experience
            </Box>

            <Flex
                flexDirection={{ base: "row", sm: "column" }}
                wrap={"wrap"}
                alignItems={"center"}
                justifyContent={"center"}
                width={"100%"}
                gap={5}
            >
                <ExperienceCard {...zenithWork}
                    isHovered={is1Hovered}
                    setIsHovered={setIs1Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
                <ExperienceCard {...speakEasyWork}
                    isHovered={is2Hovered}
                    setIsHovered={setIs2Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
                <ExperienceCard {...bbpWork}
                    isHovered={is3Hovered}
                    setIsHovered={setIs3Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
            </Flex>
        </Flex>
    );
};
